import React, { Component } from "react";
import Github from "./Github.js";

export class Name extends Component {
  render() {
    return (
      <div className="intro fadeIn">
        <hr />
        <h3>
          WELCOME TO MY INTERACTIVE RESUME
          <br />
        </h3>
        <br />
        <p>
          I designed and built this site myself with HTML, CSS, and React.js.{" "}
          <br />
          If you're a prospective employer, I'm honored and thankful that you're
          taking the time to view my work. <br />
          This project has been an incredible learning experience and it is my
          absolute pleasure to share it with you!
          <br />
        </p>
        <hr />
        <h3>Github Feed</h3>
        <br />
        <Github />
        <hr />
        <h3>AE Test</h3>
        <br />
        <p>
          <a href="https://brad-dev.theappreciationengine.com/brand/wyld-stallyns/register/237?return=https://bradvatne.github.io/interactive-resume/">
            Click this redirect link
          </a>
        </p>
        <hr />
        <h3>Social Login AE Test</h3>
        <ul>
          {" "}
          <li>
            <a href="#" data-ae-register-link="facebook">
              Register with Facebook V2
            </a>
          </li>{" "}
          <li>
            <a href="#" data-ae-register-link="twitter">
              Register with Twitter V2
            </a>
          </li>{" "}
          <li>
            <a href="#" data-ae-register-link="spotify">
              Register with Spotify V2
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

export default Name;
